<template>
  <div>
    <SkillLogoComponent name="TypeScript" src="/img/tech/typescript.png" />
    <SkillLogoComponent name="Solidity" src="/img/tech/solidity.png" />
    <SkillLogoComponent name="NestJS" src="/img/tech/nestjs.png" />
    <SkillLogoComponent name="Koa.js" src="/img/tech/koajs.png" />
    <br>
    <SkillLogoComponent name="Kafka" src="/img/tech/kafka.png" />
    <SkillLogoComponent name="MongoDB" src="/img/tech/mongo.png" />
    <SkillLogoComponent name="Elasticsearch" src="/img/tech/elasticsearch.png" />
    <SkillLogoComponent name="GraphQL" src="/img/tech/graphql.png" />
    <SkillLogoComponent name="Vue.JS" src="/img/tech/vuejs.png" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import SkillLogoComponent from './SkillLogoComponent.vue';

export default defineComponent({
  name: "SkillLogosComponent",
  components: {
    SkillLogoComponent,
  },
});
</script>